import { useContext } from 'react';
import { AjaxContext, AppContext, EMPTY_OBJECT } from 'commons-ui';
import { isNil } from 'lodash';
import { PAGE_NAMES, MISCELLANEOUS_RESOURCES } from 'constant';

const useAction = (params: any) => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName },
		showAlert
	} = useContext(AppContext);
	const { rowData = EMPTY_OBJECT, setShowLoader, filters } = params;

	const requestOrGenerateInvoiceUrl = async (
		zupeeUserId: number,
		tournamentIds: number[],
		gameName: any,
		tid: number,
		invoiceType: string | null
	) => {
		try {
			setShowLoader(true);
			const response: any = await postData({
				endpoint: `/dashboard/generateInvoice/${PAGE_NAMES.miscellaneous}-${MISCELLANEOUS_RESOURCES.invoiceGeneration}-generateInvoice`,
				queryParams: {
					appName
				},
				body: { zupeeUserId, tournamentIds, gameName, tid, invoiceType }
			});
			return response;
		} catch (error) {
			showAlert('Error while requesting invoice!', { type: 'error' });
			return null;
		} finally {
			setShowLoader(false);
		}
	};

	const onDownloadPdf = async () => {
		try {
			const invoiceType: string | null = filters?.invoiceType;
			const gameName: string | null = filters?.gameName;
			const response: any = await requestOrGenerateInvoiceUrl(
				rowData?.zupeeUserId || rowData?.uid,
				[rowData?.ltid || rowData?.insurancePackCode],
				gameName,
				rowData?.tid,
				invoiceType
			);
			if (response?.data?.success && response?.data?.invoiceUrls?.length > 0 && !isNil(invoiceType)) {
				const taxInvoiceData: any = response?.data?.invoiceUrls.filter((data: any) => {
					return data.invoiceType === invoiceType;
				});
				const downloadUrl: string = taxInvoiceData[0].signedUrl;
				const link = document.createElement('a');
				link.href = downloadUrl;
				link.setAttribute('download', `${downloadUrl}`);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} else {
				showAlert('Error while getting invoice data!', { type: 'error' });
			}
		} catch (error) {
			showAlert('Error while downloading invoice, Please refresh!', { type: 'error' });
		}
	};

	return {
		requestOrGenerateInvoiceUrl,
		onDownloadPdf
	};
};

export default useAction;
